// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"2ba9d35e","170":"fee760e9","452":"599e7203","482":"87c2a491","741":"200d1b1e","786":"4acc86ec","787":"892ae93f","991":"a2cbc6a3"}[chunkId] + ".chunk.js";
};